import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-mist border-y border-line" data-id="element-323" data-mp="3sqbmhm39w97g">
      <div className="max-w-7xl mx-auto px-4" data-id="element-324" data-mp="3srmphjow9cxi">
        <div className="text-center mb-7" data-id="element-325" data-mp="3nzv5js08u5gc">
          <h2 className="text-ink font-bold tracking-widest uppercase text-sm" data-id="element-326" data-mp="3ny0o4no6kvh0">
            What Workplace Safety Instructors Are Saying
          </h2>
          <p className="text-xs text-graphite/60 mt-2 max-w-2xl mx-auto" data-id="element-327" data-mp="mrgocokg47s">
            The following are fictional review placeholders showing the intended layout. Replace them
            with authentic, permissioned customer reviews before publishing.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-328" data-mp="aiugvczuxss3">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-line p-6 rounded-2xl shadow-sm shadow-ink/5 flex flex-col" data-id="element-329" data-mp="2cc20gymi6wjs" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-330" data-mp="q4nk7ikbnwzy">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" aria-hidden="true" data-id="element-331" data-mp="v2xfru9ykzm3" data-mpi={starIndex} />)}
              </div>
              <p className="text-graphite italic mb-6 text-sm leading-relaxed" data-id="element-332" data-mp="1044l7mompmpl">
                “{testimonial.text}”
              </p>
              <div className="mt-auto pt-4 border-t border-line" data-id="element-333" data-mp="19389r66keubh">
                <div className="font-bold text-forest text-sm" data-id="element-334" data-mp="35v9s25lhj2i1">{testimonial.name}</div>
                {testimonial.role && <div className="text-xs text-gold-dark font-semibold mt-0.5" data-id="element-335" data-mp="3atjnmhb4g546">{testimonial.role}</div>}
                <div className="flex items-center gap-1.5 text-xs text-graphite/60 mt-1.5" data-id="element-336" data-mp="i0nst5113b5v">
                  <img src={`https://flagcdn.com/${testimonial.countryCode}.svg`} alt="" aria-hidden="true" className="w-[18px] h-[13px] rounded-[2px] object-cover shrink-0 ring-1 ring-black/5" data-id="element-337" data-mp="d1tcc9qj9yox" />
                  {testimonial.country}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}